// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bounce-1{animation-delay:2.5s!important}.bounce-1,.bounce-2{animation:bouncing 5s ease infinite}@keyframes bouncing{0%{transform:translateZ(0)}50%{transform:translate3d(0,40px,0)}to{transform:translateZ(0)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
